import { render, staticRenderFns } from "./OperatePlaformModal.vue?vue&type=template&id=7dcb2baf&scoped=true&"
import script from "./OperatePlaformModal.vue?vue&type=script&lang=js&"
export * from "./OperatePlaformModal.vue?vue&type=script&lang=js&"
import style0 from "./OperatePlaformModal.vue?vue&type=style&index=0&id=7dcb2baf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcb2baf",
  null
  
)

export default component.exports